import request from '../utils/request'

export function signupConfirmInfo(data) { // 获取报名确认信息
  return request({
    url: '/api/signup/info/getConfirmInfo',
    method: 'POST',
    data
  })
}

export function admissionList(data) { // 准考证列表
  return request({
    url: '/api/signup/info/admissionList',
    method: 'POST',
    data
  })
}

export function admissionDetail(data) { // 准考证详情
  return request({
    url: '/api/signup/info/admissionDetail',
    method: 'POST',
    data
  })
}

export function submitInfo(data) { // 提交报名
  return request({
    url: '/api/signup/info/submit',
    method: 'POST',
    data
  })
}

export function subjectList(data) { // 科目列表
  return request({
    url: '/api/signup/subject/index',
    method: 'POST',
    data
  })
}

